import type {ReactElement} from 'react';
import {useEffect, useRef, useState} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';
import {ActionMenu} from '@Components/action-menu/action-menu';
import type {ActionMenuFlyoutProps} from './action-menu-flyout.types';
import {FLYOUT_HOVER_INTENT_MS, FLYOUT_TOP_ALIGN_OFFSET} from './action-menu-flyout.types';
import styles from './action-menu-flyout.module.scss';

export function ActionMenuFlyout({items, triggerText, triggerIcon, infoNote, isDisabled}: ActionMenuFlyoutProps): ReactElement {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const scheduleOpen = (open: boolean): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout((): void => {
      setIsOpen(open);
    }, FLYOUT_HOVER_INTENT_MS);
  };

  useEffect(() => {
    return (): void => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Dropdown
      open={isOpen}
      stopClickPropagation
      doCloseOnInnerClick={false}
      position={DROPDOWN_POSITION.FIXED}
      alignment={ALIGNMENT_TYPE.RIGHT_START}
      topOffset={FLYOUT_TOP_ALIGN_OFFSET}
      popupClassName={styles.flyoutPopup}
      selector={
        <div
          onMouseEnter={(): void => {
            scheduleOpen(true);
          }}
          onMouseLeave={(): void => {
            scheduleOpen(false);
          }}
        >
          <ControlledListItemType7 id="action-menu-trigger" icon={triggerIcon} text={triggerText} rightIcon="icon-caret-right" className="radius-8" isDisabled={isDisabled} />
        </div>
      }
      popup={
        <div
          onMouseEnter={(): void => {
            scheduleOpen(true);
          }}
          onMouseLeave={(): void => {
            scheduleOpen(false);
          }}
        >
          <ActionMenu isMobile={false} items={items} infoNote={infoNote} />
        </div>
      }
    />
  );
}
